import { render, staticRenderFns } from "./SubmissionModal.vue?vue&type=template&id=1780261c&scoped=true"
import script from "./SubmissionModal.vue?vue&type=script&lang=ts"
export * from "./SubmissionModal.vue?vue&type=script&lang=ts"
import style0 from "./SubmissionModal.vue?vue&type=style&index=0&id=1780261c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780261c",
  null
  
)

export default component.exports